// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZeEX","label":"styles_label__2Wnwa"};